import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { IconChevronDownSolid, IconChevronUpSolid } from '@circlefin/euclid-icons';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { useCodeSnippetContext } from '../CodeSnippet.Context/index.es.js';

const CodeSnippetExpand = ({ className, ...props })=>{
    const { lines, tokens, condensed, setCondensed, locale } = useCodeSnippetContext();
    const handleShowClick = useCallback(()=>{
        setCondensed((prev)=>!prev);
    }, [
        setCondensed
    ]);
    // Only render if there are more lines than the limit
    if (lines >= tokens.length) {
        return null;
    }
    return jsx("div", {
        className: classNames('code-snippet-expand', className),
        ...props,
        children: jsx(Button, {
            intent: "default",
            onClick: handleShowClick,
            size: "sm",
            variant: "text",
            children: condensed ? jsxs(Fragment, {
                children: [
                    locale.showMore,
                    jsx(IconChevronDownSolid, {
                        size: 20
                    })
                ]
            }) : jsxs(Fragment, {
                children: [
                    locale.showLess,
                    jsx(IconChevronUpSolid, {
                        size: 20
                    })
                ]
            })
        })
    });
};
CodeSnippetExpand.displayName = 'CodeSnippet.Expand';

export { CodeSnippetExpand };
//# sourceMappingURL=CodeSnippet.Expand.es.js.map
